



import React from 'react';
import { CheckCircle, TrendingUp, Users, Zap, Shield, Globe, ArrowRight, BarChart3, Settings, Truck, Clock, Target, Star, PlayCircle, Award, Layers } from 'lucide-react';
import { Link ,useNavigate} from 'react-router-dom';
const InforSupplyChain = () => {


    const navigate=useNavigate()
     const handleClick = () => {
       // Handle button click
       navigate('/contact')
       window.scrollTo(0,0)
     }
  const services = [
    {
      title: "End-to-End Implementation",
      description: "From planning to deployment, we manage your entire SCP implementation, aligning the platform with your business processes and KPIs.",
      icon: <Settings className="w-8 h-8" />,
      color: "#3B82F6"
    },
    {
      title: "Forecasting & Demand Planning Setup",
      description: "We help configure AI-powered forecasting tools that reduce error margins, improve inventory planning, and align sales with operations.",
      icon: <TrendingUp className="w-8 h-8" />,
      color: "#10B981"
    },
    {
      title: "Supply & Production Planning",
      description: "PTKCS enables smarter procurement and production scheduling by connecting planning data to real-time capacity and material availability.",
      icon: <Truck className="w-8 h-8" />,
      color: "#8B5CF6"
    },
    {
      title: "Integration with ERP Systems",
      description: "We ensure Infor SCP integrates smoothly with existing ERP platforms (e.g., Infor LN, M3, CSI) for seamless data flow and visibility.",
      icon: <Globe className="w-8 h-8" />,
      color: "#F59E0B"
    },
    {
      title: "Training & Change Enablement",
      description: "We empower your team with hands-on training, adoption strategies, and documentation so they can confidently manage the system.",
      icon: <Users className="w-8 h-8" />,
      color: "#EF4444"
    },
    {
      title: "Support & Optimization",
      description: "Post-go-live, we provide ongoing support, performance monitoring, and fine-tuning to ensure long-term success and ROI.",
      icon: <Shield className="w-8 h-8" />,
      color: "#06B6D4"
    }
  ];

  const benefits = [
    {
      title: "Improved Forecast Accuracy",
      description: "Leverage AI/ML to anticipate demand more precisely and reduce planning errors by up to 30%.",
      icon: <Target className="w-6 h-6" />,
      metric: "30%",
      metricLabel: "Error Reduction"
    },
    {
      title: "Lower Inventory Costs",
      description: "Avoid excess stock and stockouts by optimizing inventory across your supply chain.",
      icon: <BarChart3 className="w-6 h-6" />,
      metric: "25%",
      metricLabel: "Cost Savings"
    },
    {
      title: "Faster Response to Market Changes",
      description: "Adapt your supply chain plans in real time based on actual market behavior or disruptions.",
      icon: <Zap className="w-6 h-6" />,
      metric: "50%",
      metricLabel: "Faster Response"
    },
    {
      title: "Cross-Functional Collaboration",
      description: "Break down silos between departments with unified data and planning tools.",
      icon: <Users className="w-6 h-6" />,
      metric: "40%",
      metricLabel: "Better Collaboration"
    },
    {
      title: "Scalable Cloud Architecture",
      description: "Deploy faster, scale easily, and access your data securely from anywhere.",
      icon: <Globe className="w-6 h-6" />,
      metric: "99.9%",
      metricLabel: "Uptime"
    },
    {
      title: "Better Service Levels",
      description: "Improve fulfillment rates, on-time delivery, and customer satisfaction.",
      icon: <Clock className="w-6 h-6" />,
      metric: "95%",
      metricLabel: "On-Time Delivery"
    }
  ];

  const whyChooseUs = [
    {
      title: "Local Expertise",
      description: "Located in Indonesia, with strong understanding of Southeast Asian supply chain challenges",
      icon: <Globe className="w-6 h-6" />
    },
    {
      title: "Proven Experience",
      description: "Infor-experienced team trained in deploying and supporting Infor SCP in real-world conditions",
      icon: <Award className="w-6 h-6" />
    },
    {
      title: "Customized Approach",
      description: "Solutions tailored to match your industry, business goals, and operational model",
      icon: <Layers className="w-6 h-6" />
    },
    {
      title: "Ongoing Partnership",
      description: "Continuous collaboration and support that extends well beyond implementation",
      icon: <Shield className="w-6 h-6" />
    }
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#FFFFFF' }}>
      {/* Hero Section */}
      <div className="relative overflow-hidden" style={{ 
        background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 50%, #0F172A 100%)'
      }}>
        {/* Background Pattern */}
        <div 
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}
        />
        
        <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center min-h-screen ">
            {/* Left Content */}
            <div className="space-y-2">
           
              {/* Main Heading */}
              <div className="space-y-2">
                <h1 className="text-5xl lg:text-5xl font-black leading-tight" style={{ color: '#FFFFFF' }}>
                  Transform Your
                  <span 
                    className="block text-5xl lg:text-5xl"
                    style={{
                      background: 'linear-gradient(135deg, #60A5FA 0%, #3B82F6 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text'
                    }}
                  >
                    Supply Chain
                  </span>
                </h1>
                
                <p className="text-xl leading-relaxed max-w-2xl" style={{ color: '#CBD5E1' }}>
                  Harness the power of <span className="font-semibold" style={{ color: '#FFFFFF' }}>Infor Supply Chain Planning</span> with an  AI-driven insights and local expertise from your Local Experts
                </p>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-2 pt-4 mb-10">
                 <Link to="/contact">
                    <button 
                  className="group inline-flex items-center justify-center px-8 py-4 font-semibold rounded-xl transition-all duration-200 hover:scale-105 shadow-lg hover:shadow-xl"
                  style={{ 
                    backgroundColor: '#3B82F6',
                    color: '#FFFFFF'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#2563EB'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#3B82F6'}
                >
                  Start Your Transformation
                  <ArrowRight className="ml-3 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </button>
                
                 
                </Link>
              
                
              </div>

              {/* Stats */}
              <div className="grid grid-cols-3 gap-6 pt-8 border-t mt-10" style={{ borderColor: '#475569' }}>
                <div className="text-center">
                  <div className="text-2xl lg:text-3xl font-black" style={{ color: '#FFFFFF' }}>99.9%</div>
                  <div className="text-sm" style={{ color: '#94A3B8' }}>Uptime SLA</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl lg:text-3xl font-black" style={{ color: '#FFFFFF' }}>50+</div>
                  <div className="text-sm" style={{ color: '#94A3B8' }}>Implementations</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl lg:text-3xl font-black" style={{ color: '#FFFFFF' }}>24/7</div>
                  <div className="text-sm" style={{ color: '#94A3B8' }}>Support</div>
                </div>
              </div>
            </div>

            {/* Right Content - Hero Visual */}
            <div className="relative">
              <div className="relative">
                <img
                  src="https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&h=600&fit=crop&crop=center"
                  alt="Modern supply chain operations"
                  className="w-full h-[400px] rounded-2xl shadow-2xl object-cover"
                />
                
                {/* Floating Cards */}
               
              
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Services Section */}
      <section className="py-10 lg:py-10" style={{ backgroundColor: '#F8FAFC' }}>
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          {/* Section Header */}
          <div className="text-center mb-10">
            <h2 className="text-3xl lg:text-3xl font-black mb-6" style={{ color: '#0F172A' }}>
              Our Service <span className='text-3xl lg:text-3xl '  style={{ color: '#3B82F6' }}>Offerings</span>
            </h2>
            <p className="text-xl max-w-3xl mx-auto" style={{ color: '#475569' }}>
              End-to-end Infor SCP solutions designed to transform your supply chain operations
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div key={index} className="group">
                <div 
                  className="rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 h-full border hover:-translate-y-2"
                  style={{ backgroundColor: '#FFFFFF', borderColor: '#E2E8F0' }}
                  onMouseEnter={(e) => e.target.style.borderColor = '#CBD5E1'}
                  onMouseLeave={(e) => e.target.style.borderColor = '#E2E8F0'}
                >
                  <div 
                    className="inline-flex p-4 rounded-xl mb-6 shadow-lg"
                    style={{ backgroundColor: service.color, color: '#FFFFFF' }}
                  >
                    {service.icon}
                  </div>
                  <h3 className="text-xl font-bold mb-4 group-hover:text-blue-600 transition-colors" style={{ color: '#0F172A' }}>
                    {service.title}
                  </h3>
                  <p className="leading-relaxed mb-6" style={{ color: '#475569' }}>
                    {service.description}
                  </p>
                 
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-10 lg:py-0" style={{ backgroundColor: '#FFFFFF' }}>
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          {/* Section Header */}
          <div className="text-center mb-16">
           
            <h2 className="text-3xl lg:text-3xl font-black mb-6" style={{ color: '#0F172A' }}>
              Business <span  className='text-3xl lg:text-3xl ' style={{ color: '#10B981' }}>Outcomes</span>
            </h2>
            <p className="text-xl max-w-3xl mx-auto text-center" style={{ color: '#475569' }}>
              Drive tangible improvements across your entire supply chain operation
            </p>
          </div>

          {/* Benefits Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="group">
                <div 
                  className="rounded-2xl p-6 transition-all duration-300 hover:shadow-lg border h-full"
                  style={{ backgroundColor: '#F8FAFC', borderColor: '#E2E8F0' }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#FFFFFF';
                    e.target.style.borderColor = '#CBD5E1';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#F8FAFC';
                    e.target.style.borderColor = '#E2E8F0';
                  }}
                >
                  <div className="flex items-start justify-between mb-4">
                    <div 
                      className="w-12 h-12 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform"
                      style={{ backgroundColor: '#3B82F6', color: '#FFFFFF' }}
                    >
                      {benefit.icon}
                    </div>
                    <div className="text-right">
                      <div className="text-2xl font-black" style={{ color: '#3B82F6' }}>{benefit.metric}</div>
                      <div className="text-xs font-medium" style={{ color: '#64748B' }}>{benefit.metricLabel}</div>
                    </div>
                  </div>
                  <h3 className="text-lg font-bold mb-3 group-hover:text-blue-600 transition-colors" style={{ color: '#0F172A' }}>
                    {benefit.title}
                  </h3>
                  <p className="text-sm leading-relaxed" style={{ color: '#475569' }}>
                    {benefit.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-10 lg:py-10" style={{ 
        background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 100%)'
      }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Section Header */}
          <div className="text-center mb-16">
           
            <h2 className="text-3xl lg:text-3xl font-black mb-6" style={{ color: '#FFFFFF' }}>
              Why Choose <span  className='text-2xl lg:text-2xl' style={{ color: '#60A5FA' }}>Us </span>
            </h2>
            <p className="text-xl max-w-3xl mx-auto text-center" style={{ color: '#CBD5E1' }}>
              Your trusted partner for supply chain transformation in Southeast Asia
            </p>
          </div>

          {/* Content Grid */}
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Left - Image */}
            <div className="relative order-2 lg:order-1">
              <img
                src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&h=450&fit=crop&crop=center"
                alt="Professional team collaborating"
                className="w-full rounded-2xl shadow-2xl object-cover"
              />
              <div 
                className="absolute inset-0 rounded-2xl"
                style={{ backgroundColor: 'rgba(59, 130, 246, 0.1)' }}
              ></div>
            </div>

            {/* Right - Benefits */}
            <div className="space-y-4 order-1 lg:order-2">
              {whyChooseUs.map((point, index) => (
                <div 
                  key={index} 
                  className="flex items-start gap-4 p-2 rounded-xl transition-colors"
                  style={{ backgroundColor: 'transparent' }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(30, 41, 59, 0.5)'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  <div 
                    className="flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center"
                    style={{ backgroundColor: '#3B82F6', color: '#FFFFFF' }}
                  >
                    {point.icon}
                  </div>
                  <div>
                    <h3 className="text-lg font-bold mb-2" style={{ color: '#FFFFFF' }}>{point.title}</h3>
                    <p className="leading-relaxed" style={{ color: '#CBD5E1' }}>{point.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>


        </div>
      </section>

      {/* Call to Action */}
      <section className="py-10" style={{ backgroundColor: '#FFFFFF' }}>
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
         
          <h2 className="text-4xl lg:text-5xl font-black mb-6" style={{ color: '#0F172A' }}>
            Ready to Transform Your Supply Chain?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto" style={{ color: '#475569' }}>
            Let's discuss how KCS  Tech can help optimize your supply chain planning and drive measurable results for your business.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">

            <button 
              onClick={handleClick}
              className="group px-6 py-2 font-semibold rounded-xl transition-all duration-200 hover:scale-105 shadow-lg hover:shadow-xl"
              style={{ backgroundColor: '#3B82F6', color: '#FFFFFF' }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#2563EB'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#3B82F6'}
            >
             Schedule Consultation
              <ArrowRight className="inline ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>
            
          </div>
          
        </div>
      </section>
    </div>
  );
};

export default InforSupplyChain;
